import { render } from "./ReasoningBlock.vue?vue&type=template&id=7d557c56&scoped=true"
import script from "./ReasoningBlock.vue?vue&type=script&lang=js"
export * from "./ReasoningBlock.vue?vue&type=script&lang=js"

import "./ReasoningBlock.vue?vue&type=style&index=0&id=7d557c56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d557c56"]])

export default __exports__